import _ from 'lodash';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FMPHeadline from '../../components/ui/FMPHeadline';
import VendorBillsContainer from '../../containers/billing/VendorBills';
import EnhancedTableHead from '../../components/EnhancedTableHead';
//import { getDocuments } from '../accounting/general';
//import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import PendingIcon from '@material-ui/icons/AccessTime';
import SentIcon from '@material-ui/icons/Send';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import ViewBulkInvoiceLogDialog from '../../components/Dialogs/ViewBulkInvoiceLogDialog';

import { isFiltered, sortTable, PureRecordRow } from '../../libs/utility';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';

const invoiceStatusClassNames = {
	pending: {
		fontWeight: 900,
		color: '#2196F3',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	invalid: {
		fontWeight: 900,
		color: '#FF500F',
	},
	sent: {
		fontWeight: 900,
		color: '#FF500F',
	},
	cancelled: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingVeryOld: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingOld: {
		fontWeight: 900,
		color: '#FF9800',
	},
	normal: {
		color: '#616161',
		fontWeight: 900,
	},
	completed: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	paid: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	notFullyLinked: {
		fontWeight: 900,
		color: '#FF9800',
	},
	fullyLinked: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	allMarkedTransfers: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	allLinkedAndMarkedTransfers: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};

const styles = (theme) => ({
	...invoiceStatusClassNames,
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('md')]: {
			padding: '10px 20px 20px 20px',
		},
		borderRadius: 0,
	},
	table: {
		width: '100%',
		tableLayout: 'auto',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
	invoiceDocument: {
		position: 'absolute',
	},
	invoiceDocumentContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
	quickbooksIcon: {
		display: 'inline-block',
		width: 40,
		height: 40,
		backgroundImage: `url('${quickbooksLogo}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

//const columnStyle = { whiteSpace : 'nowrap' };
const pendingColumns = [
	{
		id: 'vendorBillId',
		label: 'Vendor Bill #',
	},
	{
		id: 'typeOfBillDisplay',
		label: 'Type of Bill',
		padding: 'checkbox',
	},
	{
		id: 'vendorDisplay',
		label: 'Vendor',
	},
	{
		id: 'billNumber',
		label: 'Bill Number',
	},
	{
		id: 'billDateSort',
		label: 'Billing Date',
	},
	{
		id: 'total',
		label: 'Total',
	},
	{
		id: 'quickbooksBillUrl',
		label: 'QB Url',
	},
	{
		id: 'linkStatusDisplay',
		label: 'Link Status',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		padding: 'checkbox',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const completedColumns = pendingColumns;

// Create our number formatter.
const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	// the default value for minimumFractionDigits depends on the currency
	// and is usually already 2
});

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

class VendorBills extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'pending');

		const startingTabIndex =
			{
				pending: 0,
				completed: 1,
			}[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			pendingOrder: 'desc',
			pendingOrderBy: 'vendorBillId',
			completedOrder: 'desc',
			completedOrderBy: 'vendorBillId',
			search: '',
			filterMap: {},

			isViewDialogOpen: false,
			viewBulkInvoice: undefined,

			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],

			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,

			pendingRows: undefined,
			completedRows: undefined,
		};
	}

	componentDidMount() {
		const { pendingVendorBills, completedVendorBills } = this.props;
		const { pendingOrder, pendingOrderBy, completedOrder, completedOrderBy } = this.state;

		const newState = {};

		if (!pendingVendorBills) {
			this.props.searchVendorBills({
				status: 'pending',
			});
		} else {
			const data = this.formatVendorBills({
				vendorBills: this.props.pendingVendorBills,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		if (!completedVendorBills) {
			this.props.searchVendorBills({
				status: 'completed',
				afterDate: moment().subtract(20, 'days').format('YYYY-MM-DD'),
			});
		} else {
			const data = this.formatVendorBills({
				vendorBills: this.props.completedVendorBills,
			});
			newState.completedRows = sortTable({
				data,
				order: completedOrder,
				orderBy: completedOrderBy,
			});
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { pendingOrder, pendingOrderBy, completedOrder, completedOrderBy } = this.state;

		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.pendingVendorBills !== this.props.pendingVendorBills) {
			const data = this.formatVendorBills({
				vendorBills: this.props.pendingVendorBills,
				statusType: 'pending',
			});
			newState.pendingRows = sortTable({ data, order: pendingOrder, orderBy: pendingOrderBy });
		}

		if (prevProps.completedVendorBills !== this.props.completedVendorBills) {
			const data = this.formatVendorBills({
				vendorBills: this.props.completedVendorBills,
			});
			newState.completedRows = sortTable({
				data,
				order: completedOrder,
				orderBy: completedOrderBy,
			});
		}

		//- Sort
		if (prevState.pendingOrder !== pendingOrder || prevState.pendingOrderBy !== pendingOrderBy) {
			newState.pendingRows = sortTable({
				data: this.state.pendingRows,
				order: pendingOrder,
				orderBy: pendingOrderBy,
			});
		}

		if (
			prevState.completedOrder !== completedOrder ||
			prevState.completedOrderBy !== completedOrderBy
		) {
			newState.completedRows = sortTable({
				data: this.state.completedRows,
				order: completedOrder,
				orderBy: completedOrderBy,
			});
		}

		//- Type to search needs to filter
		if (prevState.search !== this.state.search) {
			newState.filterMap = this.getFilterMap();
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	getFilterMap = () => {
		const { search, pendingRows, completedRows } = this.state;
		const filterMap = {};
		pendingRows.concat(completedRows).forEach((row) => {
			if (
				isFiltered({
					search,
					data: row,
					fields: ['vendorBillId', 'vendorDisplay', 'billNumber'],
				})
			) {
				filterMap[row.vendorBillId] = true;
			}
		});
		return filterMap;
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePendingSort = (orderBy) => {
		let order = 'desc';
		if (this.state.pendingOrderBy === orderBy && this.state.pendingOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ pendingOrder: order, pendingOrderBy: orderBy });
	};

	handleCompletedSort = (orderBy) => {
		let order = 'desc';
		if (this.state.completedOrderBy === orderBy && this.state.completedOrder === 'desc') {
			order = 'asc';
		}
		this.setState({ completedOrder: order, completedOrderBy: orderBy });
	};

	handleEdit = (vendorBillId) => {
		this.props.history.push(`/billing/vendorBill/update/${vendorBillId}`);
	};

	handleRowClick = (vendorBillId, type) => {
		let viewBulkInvoice;

		if (type === 'pending') {
			const { pendingVendorBills } = this.props;
			viewBulkInvoice = _.find(pendingVendorBills, { vendorBillId });
		} else if (type === 'completed') {
			const { completedVendorBills } = this.props;
			viewBulkInvoice = _.find(completedVendorBills, { vendorBillId });
		}
		this.setState({
			viewBulkInvoice,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewBulkInvoice: undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	/*
	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen : true,
			invoiceDocumentsPoppedUp : invoiceDocuments,
		});
	};
	 */

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	formatVendorBills = ({ vendorBills, statusType }) => {
		const ret = [];
		const {
			supplierMap,
			carrierMap,
			//resourceMap,
		} = this.props;

		vendorBills.forEach((vendorBill) => {
			const {
				vendorBillId,
				typeOfBill,
				supplierId,
				carrierId,
				billDate,
				total,
				billNumber,
				linkStatus,
				linkMessage,
				quickbooksBillUrl,
			} = vendorBill;

			let status = vendorBill.status;

			let vendorDisplay;
			if (carrierId) {
				const carrier = carrierMap[carrierId] || { name: 'Missing' };
				vendorDisplay = carrier.name;
			} else if (supplierId) {
				const supplier = supplierMap[supplierId] || { name: 'Missing' };
				vendorDisplay = supplier.name;
			} else {
				vendorDisplay = 'No Vendor';
			}

			let billMoment = moment(billDate);
			let billDateSort = billMoment.format('YYYY-MM-DD');
			let billDateDisplay = billMoment.format('ddd, M/D');

			let totalDisplay = <span>{moneyFormatter.format(total)}</span>;

			/*
			//- Bulk Invoice
			const invoiceDocuments = invoiceDocumentIds.map(invoiceDocumentId => {
				return invoiceDocumentMap[invoiceDocumentId] || {name: 'MISSING'};
			});

			const {uploadedInvoiceDocuments} = getDocuments({
				stationDelivery : bulkDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			*/

			const statusDisplay =
				{
					pending: 'Pending',
					completed: 'Completed',
					sent: 'Sent (Missing QB)',
					invalid: 'Marked Invalid',
					pendingOld: (
						<Fragment>
							<div>Pending</div>
							<div>(4+ days old)</div>
						</Fragment>
					),
					pendingVeryOld: (
						<Fragment>
							<div>Pending!</div>
							<div>(6+ days old)</div>
						</Fragment>
					),
				}[status] || status;

			const linkStatusDisplay =
				{
					notFullyLinked: 'Not Linked',
					fullyLinked: '100% Linked',
					allMarkedTransfers: '100% Marked Transfers',
					allLinkedAndMarkedTransfers: '100% Linked & Transfers',
				}[linkStatus] || linkStatus;

			ret.push({
				vendorBillId,
				typeOfBillDisplay: typeOfBill.toUpperCase(),
				vendorDisplay,
				billDateDisplay,
				billDateSort,
				status,
				statusDisplay,
				totalDisplay,
				linkStatusDisplay,
				linkStatus,
				linkMessage,
				billNumber,
				quickbooksBillUrl,
				rowClick: () => {
					this.handleRowClick(vendorBillId, statusType);
				},
			});
		});
		return ret;
	};

	render() {
		const { classes, canMakeUpdates, resourceMap, theme } = this.props;

		const {
			pendingRows,
			completedRows,
			pendingOrder,
			pendingOrderBy,
			completedOrder,
			completedOrderBy,
			filterMap,
		} = this.state;

		if (!pendingRows || !completedRows) {
			return <div>Loading the vendor bills...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Vendor Bills"
						value={this.state.search}
						onChange={this.handleSearch}
						buttonText="ADD VENDOR BILLS"
						url="/billing/vendorBill/add"
						canMakeUpdates={canMakeUpdates}
					/>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="All Pending" icon={<PendingIcon />} />
							<Tab label="Linked & Exported" icon={<SentIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={pendingColumns}
										order={pendingOrder}
										orderBy={pendingOrderBy}
										onRequestSort={this.handlePendingSort}
									/>
									<TableBody>
										{pendingRows.map((row) => {
											if (filterMap[row.vendorBillId]) {
												return null;
											}

											return (
												<PureRecordRow hover key={row.vendorBillId}>
													<TableCell onClick={row.rowClick}>{row.vendorBillId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.typeOfBillDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.vendorDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.billNumber}</TableCell>
													<TableCell onClick={row.rowClick}>{row.billDateDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.totalDisplay}</TableCell>
													<TableCell>
														{!!row.quickbooksBillUrl && (
															<a
																href={row.quickbooksBillUrl}
																target="_blank"
																rel="noreferrer noopener"
															>
																<div className={classes.quickbooksIcon} />
															</a>
														)}
														{!row.quickbooksBillUrl && <Fragment>n/a</Fragment>}
													</TableCell>
													<TableCell onClick={row.rowClick} style={{ whiteSpace: 'nowrap' }}>
														<div className={classes[row.linkStatus]}>{row.linkStatusDisplay}</div>
														<div>{row.linkMessage}</div>
													</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.vendorBillId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<Table size="small" className={classes.table}>
									<EnhancedTableHead
										columnData={completedColumns}
										order={completedOrder}
										orderBy={completedOrderBy}
										onRequestSort={this.handleCompletedSort}
									/>
									<TableBody>
										{completedRows.map((row) => {
											if (filterMap[row.vendorBillId]) {
												return null;
											}
											return (
												<PureRecordRow hover className={classes.row} key={row.vendorBillId}>
													<TableCell onClick={row.rowClick}>{row.vendorBillId}</TableCell>
													<TableCell onClick={row.rowClick}>{row.typeOfBillDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.vendorDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.billNumber}</TableCell>
													<TableCell onClick={row.rowClick}>{row.billDateDisplay}</TableCell>
													<TableCell onClick={row.rowClick}>{row.totalDisplay}</TableCell>
													<TableCell>
														{!!row.quickbooksBillUrl && (
															<a
																href={row.quickbooksBillUrl}
																target="_blank"
																rel="noreferrer noopener"
															>
																<div className={classes.quickbooksIcon} />
															</a>
														)}
														{!row.quickbooksBillUrl && <Fragment>n/a</Fragment>}
													</TableCell>
													<TableCell onClick={row.rowClick} style={{ whiteSpace: 'nowrap' }}>
														<div className={classes[row.linkStatus]}>{row.linkStatusDisplay}</div>
														<div>{row.linkMessage}</div>
													</TableCell>

													<TableCell
														onClick={row.rowClick}
														className={classes[row.status]}
														style={{ whiteSpace: 'nowrap' }}
													>
														{row.statusDisplay}
													</TableCell>

													{canMakeUpdates && (
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(row.vendorBillId)}
															>
																Edit
															</Button>
														</TableCell>
													)}
												</PureRecordRow>
											);
										})}
									</TableBody>
								</Table>
							</TabContainer>
						</SwipeableViews>

						<InvoiceDocumentPopup
							open={this.state.isInvoiceDocumentPopupOpen}
							onClose={this.handleCloseInvoiceDocumentPopup}
							invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
							resourceMap={resourceMap}
						/>

						<InvoicePdfPopup
							open={this.state.isInvoicePdfPopupOpen}
							onClose={this.handleCloseInvoicePdfPopup}
							resourceId={this.state.invoicePdfPoppedUp}
							resourceMap={resourceMap}
						/>

						<ViewBulkInvoiceLogDialog
							open={this.state.isViewDialogOpen}
							onClose={this.handleCloseViewDialog}
							vendorBill={this.state.viewBulkInvoice}
							history={this.props.history}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

VendorBills.propTypes = {
	classes: PropTypes.object.isRequired,
	searchVendorBills: PropTypes.func.isRequired,
	//vendorBills : PropTypes.array,
	pendingVendorBills: PropTypes.array,
	completedVendorBills: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles, { withTheme: true }), VendorBillsContainer])(VendorBills);
